import { EVENT_PAGE_SIZE } from "../../pages/recent-activities/utils/constants";

export interface BuildEventQueryVariablesInput {
  customerId: string;
  facilityId?: string;
  modelId?: string;
  eventTimestamp?: string;
  fromDate?: string;
  pageSize?: number;
  lastEvaluatedKey?: string;
}

export const buildEventQueryVariables = ({
  customerId,
  facilityId,
  modelId,
  eventTimestamp,
  fromDate,
  pageSize,
  lastEvaluatedKey,
}: BuildEventQueryVariablesInput) => {
  return {
    customerId: encodeURIComponent(customerId),
    facilityId: facilityId ?? "",
    modelId: modelId ?? "",
    eventTimestamp: eventTimestamp ?? "",
    fromDate: fromDate ?? "",
    pageSize: pageSize ?? EVENT_PAGE_SIZE,
    ...(lastEvaluatedKey
      ? { lastEvaluatedKey: encodeURI(JSON.stringify(lastEvaluatedKey)) }
      : { lastEvaluatedKey: "" }),
  };
};
